import { InjectionToken } from '@angular/core';

/**
 * Resolves true в showcase-сборке (которая деплоится на showcase-домен как
 * CSR static), false в cabinet-сборке.
 *
 * Провайдер живёт в `app.module.ts`: factory сравнивает `window.location.host`
 * с `environment.showcaseUrl` (build-time константа из nextshowcase config).
 * На SSR (cabinet-only) factory возвращает false через guard `typeof window`.
 */
export const IS_SHOWCASE = new InjectionToken<boolean>('IS_SHOWCASE');
